import { render } from "./PapSmearAbove.vue?vue&type=template&id=29ad6c31&scoped=true"
import script from "./PapSmearAbove.vue?vue&type=script&lang=js"
export * from "./PapSmearAbove.vue?vue&type=script&lang=js"

import "./PapSmearAbove.vue?vue&type=style&index=0&id=29ad6c31&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29ad6c31"]])

export default __exports__